module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAkCAYAAABmMXGeAAABbklEQVRIia3Wu0sDQRDH8V8iKD4QrIKN4AMs/EPEqPgiBFEstBIFaxEs/AvsBPs0ErHURnxAbEQrsdJCRBRBLMT6a3UQ483lbseBafZ2P8zs3S2bA/QPMSqpKOlc0pEAb07xO0pecI6/cZ93tFyWVI0Zfw6tcDamQoBPYCgEnDTAL2AQUFawaIDfwHA0Lwu4aIAfQH/93LRg2QCfopazohMG+AL0xa3J+mFH8QAUrHVJ4LgBvgKdScVYD+YN8A3oadJdLGq9lFugtxkYh1rgDdCeBmxEpxPAjrRgPWr9KXdZsHp0xgBrQEsImgMeJQ00HF/vkgqhZ2Je0n7MeLekvVA0Knnb2ILD0D2NctOADzyogB0DrnjQpIqrHlTAlgGfeFABGwZ86kEFrBnwsQcVsGzAFx5UwKoBn3lQAesGfOlBhX3eXgOtoaiAJQOuAW2hqIAVA74CukJRAQsGvOu5SlYklWLGRzyVRtl4Pxj7AT6OYdH2kwegAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/back.png
// module id = ADGn
// module chunks = 1